<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">SWAP</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="mt-4 block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-no-wrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">old IMEI</th>
          <th class="px-6 pt-6 pb-4">new IMEI</th>
        </tr>
        <tr v-for="imei in imeis.data" :key="imei.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('dashboard.detail', imei.repair_id)" tabindex="-1">
              {{ imei.origin_imei }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('dashboard.detail', imei.repair_id)" tabindex="-1">
              {{ imei.new_imei }}
            </inertia-link>
          </td>
        </tr>
        <tr v-if="imeis.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No swap found.</td>
        </tr>
      </table>
    </div>
    <pagination :links="imeis.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Layouts/AppLayout'
import mapValues from 'lodash/mapValues'
import pickBy from 'lodash/pickBy'
import SearchFilter from '@/Shared/SearchFilter'
import throttle from 'lodash/throttle'
import Pagination from '@/Shared/Pagination'

export default {
  metaInfo: { title: 'SWAP' },
  layout: Layout,
  components: {
    Icon,
    SearchFilter,
    Pagination,
  },
  props: {
    imeis: Object,
    filters: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      handler: throttle(function() {
        let query = pickBy(this.form)
        this.$inertia.replace(this.route('swap.list', Object.keys(query).length ? query : { remember: 'forget' }),{
          preserveScroll: true,
          preserveState: true,
        })
      }, 150),
      deep: true,
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
